// Canonical nested paths (clients › jobs › entity) — single source of truth so the
// whole app links consistently. Mirrors the audit's target URL structure.

export const clientPath = (clientId: number | string) => `/clients/${clientId}`;

export const clientSectionPath = (clientId: number | string, section: string) =>
  `/clients/${clientId}/${section}`;

export const employeePath = (employeeId: number | string, section?: string) =>
  section ? `/employees/${employeeId}/${section}` : `/employees/${employeeId}`;

export const crewPath = (crewId: number | string, section?: string) =>
  section ? `/crews/${crewId}/${section}` : `/crews/${crewId}`;

export const agreementPath = (
  clientId: number | string | undefined | null,
  agreementId: number | string,
) => (clientId ? `/clients/${clientId}/agreements/${agreementId}` : `/agreements/${agreementId}`);

export const jobPath = (clientId: number | string | undefined | null, jobId: number | string) =>
  clientId ? `/clients/${clientId}/jobs/${jobId}` : `/jobs/${jobId}`;

export const jobSectionPath = (
  clientId: number | string | undefined | null,
  jobId: number | string,
  section: string,
) => `${jobPath(clientId, jobId)}/${section}`;

export const estimatePath = (
  clientId: number | string | undefined | null,
  jobId: number | string | undefined | null,
  estimateId: number | string,
) =>
  clientId && jobId
    ? `/clients/${clientId}/jobs/${jobId}/estimates/${estimateId}`
    : `/estimates/${estimateId}`;

export const labourEstimatePath = (
  clientId: number | string | undefined | null,
  jobId: number | string | undefined | null,
  estimateId: number | string,
) =>
  clientId && jobId
    ? `/clients/${clientId}/jobs/${jobId}/labour-estimates/${estimateId}`
    : `/labour-estimates/${estimateId}`;

export const quotePath = (
  clientId: number | string | undefined | null,
  jobId: number | string | undefined | null,
  quoteId: number | string,
) =>
  clientId && jobId
    ? `/clients/${clientId}/jobs/${jobId}/quotes/${quoteId}`
    : `/quotes/${quoteId}`;
